import FlexRow from '@/ui/FlexRow'
import styled from 'styled-components'
import { StyledFilePreviewProps } from './types'

export const StyledFilePreview = styled.div<StyledFilePreviewProps>`
  .overflow-container {
    ${props => (props.isImage ? 'display: flex;' : 'overflow: auto;')}
    height: 90vh;

    .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      margin: 75px 50px;
      overflow: auto;
      img {
        max-width: min-content;
        margin: auto;
      }
    }

    .video-container {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .audio-container {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .document-container {
      width: 100%;
      white-space: pre;
    }
    .file-outer-container {
      min-height: 90vh;
    }
    .file-outer-container .pg-viewer-wrapper {
      overflow: auto;
    }
    .actions-overflow {
      overflow: hidden;
      position: absolute;
      z-index: 5;
      width: 100%;
    }
  }

  .show-toolbar {
    transform: translateY(0);
  }
  .hide-toolbar {
    transform: translateY(-100%);
  }
  .excel-button {
    position: absolute;
    left: 0;
    top: -30px;
    height: 30px;
    button {
      height: 30px;
      background-color: ${props => props.theme.primaryColor}b3;
      border: 0;
      outline: 0;
      color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;
      i {
        color: #fff !important;
        margin-left: 5px;
        cursor: pointer !important;
      }
    }
  }
  .sheet-names {
    padding: 10px 0;
    input {
      padding: 5px;
      margin-right: 5px;
      border: 1px solid #d8dadb;
      background-color: #fff;
      outline: 0;
    }
  }
  .pg-viewer-wrapper {
    overflow-y: visible;
  }
  .document-actions {
    background-color: ${props => props.theme.primaryColor}b3;
    transition: transform 0.3s ease;
    width: 100%;
    padding: 22px 15px;
    top: 0;
    display: flex;
    color: #fff;
    justify-content: space-between;
    align-items: center;
    p {
      margin: 0;
    }
    button {
      background-color: rgba(0, 0, 0, 0);
      border: 0;
      outline: 0;
      color: #fff;
      display: flex;
      align-items: center;
      transform: translateX(-30px);
      cursor: pointer;
      i {
        color: #fff !important;
        margin-left: 5px;
        cursor: pointer !important;
      }
    }
  }
  .react-grid-HeaderCell {
    pointer-events: none;
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    min-height: 100vh;
    .overflow-container {
      height: 100vh;
    }
  }
`

export const PreviewErrorHandlerContainer = styled(FlexRow)`
  min-height: calc(90vh - 92px);
  > div {
    padding-bottom: 20px;
  }
  button {
    margin: 0;
  }
`
